import React from 'react'
import { useSelector } from 'react-redux'
import { Lineup, LineupBuilderState } from './store/types'
import { Stack, Tooltip } from '@mui/material'
import { motion } from 'framer-motion'

const SimulationResults = () => {
  const { selectedLineupId, lineups } = useSelector<any, LineupBuilderState>((state) => state.lineupBuilder)
  const { simResults } = lineups.find((x) => x.id === selectedLineupId) || {} as Lineup;

  console.log('simResults?.simRoi', parseFloat(simResults?.simRoi))

  const getROIContextColor = (context: string) => {
    if (context === 'Good') {
      return '#47C84C'
    } else if (context === 'Poor') {
      return '#ff1432'
    } else {
      return ''
    }
  }

  const getROIContextText = (context: string) => {
    if (context === 'Good') {
      return 'Great Lineup!'
    } else if (context === 'Poor') {
      return ''
    } else {
      return 'Almost There...'
    }
  }


  return (
    <Stack direction='column' rowGap='16px' height={{ xs: 'auto', lg: 'calc(100vh - 400px)' }} flexGrow={{ xs: 1, lg: 0 }} minHeight={0} overflow='auto' padding='0px'>
      <Stack pt="24px" fontSize='24px' fontWeight={700} textAlign={{ xs: 'center', md: 'inherit'}}>Simulation Results</Stack>
      <Stack fontSize='36px' fontWeight={800} color={getROIContextColor(simResults?.roiContext)} textAlign={{ xs: 'center', md: 'center'}}>{getROIContextText(simResults?.roiContext)}</Stack>
      <FadeInAnimation>
        <Tooltip title="Simulated ROI: Estimates the return on investment for your lineup.">
          <Stack direction='column' justifyContent='center' alignItems='center' padding='40px 30px' borderRadius='10px' bgcolor='#1C1C1C' rowGap='20px'>
            <Stack fontSize='24px' fontWeight={400} >SIMULATED ROI</Stack>
            <Stack fontSize='60px' fontWeight={700} color={parseFloat(simResults?.simRoi) > 0 ? '#47C84C' : '#ff1432'}>{simResults?.simRoi || '-'}</Stack>
          </Stack>
        </Tooltip>
      </FadeInAnimation>
      <FadeInAnimation>
        <Stack direction='row' justifyContent='space-between' columnGap={{xs: '8px', md: '15px'}} overflow='auto'>
          <Tooltip title="Win Odds: The likelihood of your lineup finishing in first place.">
            <Stack direction='column' justifyContent='center' alignItems='center' padding={{xs: '24px 8px', md: '40px 30px'}} borderRadius='10px' bgcolor='#1C1C1C' flexGrow={1}>
              <Stack fontSize={{xs: '12px', md: '18px'}} fontWeight={400} whiteSpace='nowrap'>WIN %</Stack>
              <Stack fontSize={{xs: '30px', md: '42px'}} fontWeight={700} color="#FFF">{simResults?.winPct || '-'}</Stack>
            </Stack>
          </Tooltip>
          <Tooltip title="Top-10% Odds: The chances of your lineup finishing in the top 10% of the contest.">
            <Stack direction='column' justifyContent='center' alignItems='center' padding={{xs: '24px 8px', md: '40px 30px'}} borderRadius='10px' bgcolor='#1C1C1C' flexGrow={1}>
              <Stack fontSize={{xs: '12px', md: '18px'}} fontWeight={400} whiteSpace='nowrap'>TOP 10 %</Stack>
              <Stack fontSize={{xs: '30px', md: '42px'}} fontWeight={700} color="#FFF">{simResults?.topTenPct || '-'}</Stack>
            </Stack>
          </Tooltip>
          <Tooltip title="Cash Percentage: The probability that your lineup will “cash,” or earn a payout in the contest.">
            <Stack direction='column' justifyContent='center' alignItems='center' padding={{xs: '24px 8px', md: '40px 30px'}} borderRadius='10px' bgcolor='#1C1C1C' flexGrow={1}>
              <Stack fontSize={{xs: '12px', md: '18px'}} fontWeight={400} whiteSpace='nowrap'>CASH %</Stack>
              <Stack fontSize={{xs: '30px', md: '42px'}} fontWeight={700} color="#FFF">{simResults?.cashPct || '-'}</Stack>
            </Stack>
          </Tooltip>
        </Stack>
      </FadeInAnimation>
      {/* <Stack direction='row' justifyContent='center' alignItems='center'>
        Build up to X lineups to compare data!
      </Stack> */}
    </Stack>
  )
}

const FadeInAnimation = ({children}) => (
  <motion.div
  initial={{ y: 10, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 1 }}
  >
    {children}
  </motion.div>
)

export default SimulationResults